import React from 'react';
import Wrapper from './styles';
import { formatPrice, getThumbnailUrl } from '../../utils/helpers';
import { Link } from 'react-router-dom';
import { useLanguageContext } from '../../context/language_context';
import { FaArrowRight, FaStar } from 'react-icons/fa';

const ListView = ({ products }) => {
  const { t } = useLanguageContext();

  return (
    <Wrapper>
      {products.map((product) => {
        const { id, image, name, price, description, originalPrice, discountPercentage, numberOfReviews, rating } = product;
        return (
          <article key={id}>
            <img src={getThumbnailUrl(image, 500)} alt={name} loading='lazy' />
            <div className='content'>
              <h4>{name}</h4>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <p className='price' style={{ marginBottom: 0 }}>{formatPrice(price)}</p>
                {originalPrice && (
                  <p className='price' style={{ textDecoration: 'line-through', color: '#9ca3af', fontSize: '0.875rem', marginBottom: 0 }}>{formatPrice(originalPrice)}</p>
                )}
                {discountPercentage > 0 && (
                  <span style={{ background: '#ef4444', color: 'white', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', fontSize: '0.75rem', fontWeight: 'bold' }}>-{discountPercentage}%</span>
                )}
              </div>
              {numberOfReviews > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} color={i < rating ? '#ffb900' : '#e4e5e9'} />
                  ))}
                  <span style={{ marginLeft: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>({numberOfReviews})</span>
                </div>
              )}
              <p>{description?.substring(0, 150)}...</p>
              <Link to={`/products/${id}`} className='btn'>
                {t.products?.quickView || 'View Details'}
                <FaArrowRight />
              </Link>
            </div>
          </article>
        );
      })}
    </Wrapper>
  );
};

export default ListView;
